import { getPaddle } from './paddle';
import QRCode from 'qrcode';

window.t = function (str, ...args) {
	return str.replace(/%[ds]/g, () => args.shift());
}

document.addEventListener('DOMContentLoaded', () => {
	window.initSmoothScrolling({
		offset: 0,
	});

	const qrHost = document.getElementById('mmq-totp-qr');
	const otpUri = qrHost?.dataset?.mmqTotpUri ? String(qrHost.dataset.mmqTotpUri) : '';

	if (qrHost && otpUri) {
		QRCode.toCanvas(otpUri, {
			width: 192,
			margin: 1,
			color: {
				dark: '#111827',
				light: '#ffffff',
			},
		}).then((canvas) => {
			qrHost.innerHTML = '';
			qrHost.appendChild(canvas);
		}).catch((err) => {
			console.error('Failed to render TOTP QR code', err);
		});
	}
});

document.addEventListener('alpine:init', () => {
	Alpine.data('pricingToggle', () => ({
		annual: false,
		busy: false,

		prices: {
			monthly: {
				starter: 5,
				pro: 16,
				business: 42
			},
			yearly: {
				starter: 4,
				pro: 13,
				business: 35
			}
		},
		paddlePriceIds: {
			monthly: {
				starter: 'pri_01kkv1m37vr9sfp5ezb32zx91q',
				pro: 'pri_01kkv1t2sbb4a7fk4bq2znrv3w',
				business: 'pri_01kkv2098pvgzzsfdz85e0hn3n'
			},
			yearly: {
				starter: 'pri_01kkv1pffg891788n8815b8km7',
				pro: 'pri_01kkv1v0ah6p4w858sn8cgsza8',
				business: 'pri_01kkv21tj781p7ac5jv8ftvnn0'
			}
		},
		paddlePriceIdsSandbox: {
			monthly: {
				starter: 'pri_01kh25xhvrk9trhy1gd1cnx8f1',
				pro: 'pri_monthly_pro',
				business: 'pri_monthly_business'
			},
			yearly: {
				starter: 'pri_01kh2619cnzq14m7jzcbcn8k5t',
				pro: 'pri_yearly_pro',
				business: 'pri_yearly_business'
			}
		},

		price(plan) {
			return this.annual
				? this.prices.yearly[plan]
				: this.prices.monthly[plan];
		},

		fmt(value) {
			return new Intl.NumberFormat('de-DE', {
				style: 'decimal',
				minimumFractionDigits: 0,
				maximumFractionDigits: 2
			}).format(value);
		},

		suffix() {
			return this.annual ? '/'+MMQSHARED.lang.month_billed_yearly : '/'+MMQSHARED.lang.month;
		},

		currency() {
			return '€';
		},

		currentPriceIds() {
			return (MMQSHARED.PaddleEnvironment === 'sandbox')
				? this.paddlePriceIdsSandbox
				: this.paddlePriceIds;
		},

		paddlePriceId(plan) {
			const ids = this.currentPriceIds();
			return this.annual
				? ids.yearly[plan]
				: ids.monthly[plan];
		},

		async startCheckout(planKey) {
			/*
			console.log({
			  env: MMQSHARED.PaddleEnvironment,
			  liveToken: MMQSHARED.PaddleClientToken,
			  sandboxToken: MMQSHARED.PaddleClientTokenSandbox,
			  chosenPriceId: this.paddlePriceId(planKey)
			});
			*/
			if (this.busy) return;

			const priceId = this.paddlePriceId(planKey);

			if (!priceId) {
				console.log('Missing price ID');
				return;
			}

			this.busy = true;

			try {
				// 1) Signup-Token von WP holen
				const body = new URLSearchParams({
					action: 'mr_paddle_create_signup',
					nonce: MMQSHARED.nonce,
					price_id: priceId,
					plan: planKey,
				});

				const res = await fetch(MMQSHARED.ajaxUrl, {
					method: 'POST',
					headers: {
						'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
					},
					body,
					credentials: 'same-origin'
				});

				const json = await res.json();

				if (!json || json.success !== true || !json.data || !json.data.signup_token) {
					throw new Error(json?.data?.message || 'signup_failed');
				}

				const signupToken = json.data.signup_token;

				// 2) Paddle laden
				const paddle = await getPaddle();

				const successUrl = new URL(MMQSHARED.PaddleSuccessUrl);
				successUrl.searchParams.set('t', signupToken);

				if (MMQSHARED.PaddleEnvironment === 'sandbox') {
					successUrl.searchParams.set('PADDLESANDBOX', '1');
				}

				// 3) Checkout öffnen
				paddle.Checkout.open({
					settings: {
						displayMode: 'overlay',
						successUrl: successUrl.toString(),
						theme: 'light',
						locale: MMQSHARED.PaddleCheckoutLocale,
					},
					items: [{ priceId, quantity: 1 }],
					"quantity": {
					  "minimum": 1,
					  "maximum": 1
					},
					customData: {
						signup_token: signupToken,
						plan: planKey,
						billing_cycle: this.annual ? 'yearly' : 'monthly',
						locale: MMQSHARED.PaddleCheckoutLocale
					},
				});

			} catch (e) {
				console.error(e);
				alert(MMQSHARED.lang.checkoutCouldNotBeStarted +' ' + (e?.message || 'unknown'));
			} finally {
				this.busy = false;
			}
		}
	}));
});

window.acToast = function(title, msg, type) {
	const host = document.getElementById('ac_toast');
	if (!host) return;

	const el = document.createElement('div');
	el.className = 'ac-toast' + (type ? (' ' + type) : '');
	el.innerHTML =
		'<div class="ac-toast-title">' + String(title || '') + '</div>' +
		'<div class="ac-toast-msg">' + String(msg || '') + '</div>';

	host.appendChild(el);

	setTimeout(() => {
		el.style.opacity = '0';
		el.style.transition = 'opacity 250ms';
		setTimeout(() => el.remove(), 260);
	}, 4500);
};

window.smoothScrollToTarget = function(target, opts = {}) {
	const {
		offset = 0,
		behavior = 'smooth',
		updateHash = true,
	} = opts;

	let el = null;

	if (typeof target === 'string') {
		el = target.startsWith('#')
			? document.querySelector(target)
			: document.getElementById(target);
	} else if (target instanceof Element) {
		el = target;
	}

	if (!el) return false;

	const top = el.getBoundingClientRect().top + window.pageYOffset - offset;

	window.scrollTo({
		top,
		behavior,
	});

	if (updateHash && el.id) {
		history.pushState(null, '', '#' + el.id);
	}

	return true;
};

window.initSmoothScrolling = function(opts = {}) {
	const {
		offset = 0,
		behavior = 'smooth',
		selector = 'a[href*="#"]',
	} = opts;

	document.addEventListener('click', (e) => {
		const link = e.target.closest(selector);
		if (!link) return;

		const href = link.getAttribute('href');
		if (!href || !href.includes('#')) return;

		let url;
		try {
			url = new URL(href, window.location.href);
		} catch (_) {
			return;
		}

		if (!url.hash) return;

		const sameHost = url.host === window.location.host;
		const samePath = url.pathname.replace(/\/+$/, '') === window.location.pathname.replace(/\/+$/, '');

		if (!sameHost || !samePath) return;

		const ok = window.smoothScrollToTarget(url.hash, {
			offset,
			behavior,
			updateHash: true,
		});

		if (ok) {
			e.preventDefault();
		}
	});
};
